let regPhone = /^1[34578]\d{9}$/; // 格式化手机号
let regEmail = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/; // 格式化邮箱
let isWeiXin = () => { return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 }
let staticHost = () => { return '//' + window.location.host + '/static/keer'}
let baseUrl = '//' + window.location.host
// let staticHost = () => { return '//' + 'html5.yztwork.com/' + '/static/keer'}
// let baseUrl = '//' + 'html5.yztwork.com/'
// localStorage 存储token
let storage = window.localStorage
function setStorage(name, val) {
    return storage.setItem(name, val)
}

function getStorage(name) {
    return storage.getItem(name)
}

function removeStorage(name) {
    return storage.removeItem(name)
}

function clearStorage() {
    return storage.clear()
}

function formatter(date) { // 2019/06/12
    let now = new Date(date)
    let year = now.getFullYear()      //年
    let month = now.getMonth() + 1     //月
    let day = now.getDate()           //日
    let clock = year + "/"
    if (month < 10)
        clock += "0"
    clock += month + "/"
    if (day < 10)
        clock += "0"
    clock += day

    return clock
}
// 计算两地之间的距离
function space(lat1, lng1, lat2, lng2) {
    var radLat1 = lat1 * Math.PI / 180.0;
    var radLat2 = lat2 * Math.PI / 180.0;
    var a = radLat1 - radLat2;
    var b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0;
    var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
    s = s * 6378.137;
    s = Math.round(s * 10000) / 10000;
    return s  // 单位千米
}

export { formatter, regPhone, regEmail, setStorage, getStorage, removeStorage, clearStorage, isWeiXin, space, baseUrl, staticHost }